export const colorScales = {
  totalChitalishta: ['#fedcc8', '#fca97e', '#fa7e38', '#fa6d24', '#fa5d11', '#d64d0f', '#b23e0d'],
  stateSubsidyAmount: ['#d1bce3', '#b995ce', '#a16db9', '#8946a4', '#711e8f', '#5e197a', '#4b1465'],
  stateSubsidyPerCapita: ['#ffc5c5', '#ff9c9c', '#ff7272', '#ff4949', '#ff2020', '#d91b1b', '#b31616'],
  revenueFromSubsidiesPercent: ['#ffeacc', '#ffd699', '#ffc266', '#ffad33', '#ff9900', '#d98200', '#b36b00'],
  expensesForSalariesPercent: ['#b3e0dc', '#80cbc4', '#4db6ac', '#26a69a', '#00897b', '#007366', '#005f52'],
  totalStaff: ['#a9b1d6', '#8791c1', '#6571ac', '#435197', '#213182', '#1b286d', '#151f58'],
  staffHigherEducationPercent: ['#f8c4d5', '#f4a8be', '#f08da7', '#ec7190', '#e85679', '#c44966', '#a03c53'],
  averageInsuranceIncome: ['#e0cffc', '#c19ef9', '#a26df6', '#843cf3', '#650bf0', '#5509cc', '#4507a8'],
  chitalishtaPer10kResidents: ['#b2d8b5', '#8fc394', '#6cb073', '#489c52', '#248831', '#1e7228', '#185c20'],
  default: ['#dcedc8', '#aed581', '#8bc34a', '#689f38', '#33691e', '#2a5618', '#214312'],
};
